import { render, staticRenderFns } from "./DashboardGroupManagerPageConfigEdit.vue?vue&type=template&id=7e4e1a06&"
import script from "./DashboardGroupManagerPageConfigEdit.vue?vue&type=script&lang=ts&"
export * from "./DashboardGroupManagerPageConfigEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports